module.exports = __webpack_public_path__ + "img/b452bb3.png";